"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _numeral = _interopRequireDefault(require("numeral"));
var _classnames = _interopRequireDefault(require("classnames"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var FrequencyTable = function FrequencyTable(props) {
  var data = props.data,
    showPercentage = props.showPercentage;
  var _useMemo = (0, _react.useMemo)(function () {
      var sum = data.reduce(function (num, item) {
        return num + item.value;
      }, 0);
      var result = data.map(function (item) {
        return _objectSpread(_objectSpread({}, item), {}, {
          percentage: sum > 0 ? item.value / sum * 100 : 0
        });
      });
      return {
        adjustedData: result,
        total: sum,
        hasCode: data.some(function (item) {
          return item.code;
        })
      };
    }, [data]),
    adjustedData = _useMemo.adjustedData,
    total = _useMemo.total,
    hasCode = _useMemo.hasCode;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].tableWrapper
  }, /*#__PURE__*/_react["default"].createElement("table", {
    className: 'table table-condensed ' + _style["default"].table
  }, /*#__PURE__*/_react["default"].createElement("thead", null, /*#__PURE__*/_react["default"].createElement("tr", null, /*#__PURE__*/_react["default"].createElement("th", null, "Value"), /*#__PURE__*/_react["default"].createElement("th", {
    className: "text-center"
  }, "Frequency"), showPercentage && /*#__PURE__*/_react["default"].createElement("th", {
    className: "text-center"
  }, "Percentage"))), /*#__PURE__*/_react["default"].createElement("tbody", null, adjustedData.map(function (row) {
    return /*#__PURE__*/_react["default"].createElement("tr", {
      key: row.label
    }, /*#__PURE__*/_react["default"].createElement("td", {
      className: (0, _classnames["default"])(row.isOthers && _style["default"].others)
    }, /*#__PURE__*/_react["default"].createElement("b", null, row.label), hasCode && 'code' in row && " (".concat(row.code, ")")), /*#__PURE__*/_react["default"].createElement("td", {
      className: "text-center"
    }, row.value), showPercentage && /*#__PURE__*/_react["default"].createElement("td", {
      className: "text-center"
    }, (0, _numeral["default"])(row.percentage).format('0.0'), "%"));
  })), /*#__PURE__*/_react["default"].createElement("tfoot", null, /*#__PURE__*/_react["default"].createElement("tr", null, /*#__PURE__*/_react["default"].createElement("td", null, "TOTAL"), /*#__PURE__*/_react["default"].createElement("td", {
    className: "text-center"
  }, total), showPercentage && /*#__PURE__*/_react["default"].createElement("td", {
    className: "text-center"
  }, "100%")))));
};
FrequencyTable.propTypes = {
  data: _propTypes["default"].array,
  showPercentage: _propTypes["default"].bool
};
var _default = exports["default"] = FrequencyTable;